var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"phone",attrs:{"href":'tel:' + _vm.telLink}},[_vm._v(_vm._s(_vm._f("formatted")(_vm.phone)))])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Phone.vue?vue&type=template&id=22e63874&
// module id = 749
// module chunks = 2